export const FutureOrdersTableSkeleton = () => {
  return (
    <div className="h-full space-y-[0.5rem]  my-[1.25rem]">
      <div className="bg-gray-100 h-[10%]  opacity-20 animate-pulse"> </div>
      <div className=" h-[80%] space-y-[0.5rem] ">
        <div className="bg-gray-100 h-[20%]  opacity-5 animate-pulse"> </div>
        <div className="bg-gray-100 h-[20%]  opacity-5 animate-pulse"> </div>

        <div className="bg-gray-100 h-[20%]  opacity-5 animate-pulse"> </div>

        <div className="bg-gray-100 h-[20%]  opacity-5 animate-pulse"> </div>

        <div className="bg-gray-100 h-[20%]  opacity-5 animate-pulse"> </div>
      </div>
    </div>
  );
};
